import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
// import { SignalRAction } from 'src/app/enums/signalr-enums';
// import { SignalRService } from 'src/app/Services/SignalR/signal-r.service';
// import { GeneralSignalRResponse } from 'src/app/_interface/signal-r-models/GeneralSignalRResponse';
import * as FormStatusesActions from '../form-status/form-status.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from '../channels';
// import { Channels } from 'src/app/Store/channels';
// import { FormType } from 'src/app/_interface/Enumerations';

@Injectable({
  providedIn: 'root'
})
export class FormStatusesStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new FormStatusesActions.FormStatusesRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.FORMSTATUSES, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new FormStatusesActions.FormStatusesCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new FormStatusesActions.FormStatusesUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new FormStatusesActions.FormStatusesDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new FormStatusesActions.FormStatusesRefresh());
          break;
      }
    });
  }
}
